import usdt from "../images/tether.png";
import rmn from "../images/RMN-token-logo.png";
import maallogo from "./../images/maal_icon.png"

export const multisigwallet = "0xC57E89Dda471f142eA3bB140eb7E7dd4f81039eC"
export const multisigwallet2 = "0xc298aCEDe98982674E199da154Eaea649a010E18"


export const maal = "maal"
const bnb = "0x0000000000000000000000000000000000000000"

export const defaultMaalReserveUSDT = 80000000;
export const defaultCirculationSupply = 150000000;


const maalID = 'maal-chain'
// const ethID = 'ethereum'
const bnbID = 'binancecoin'
// const btcID = 'bitcoin'

//https://rusd-supply-api.ribg.digital/royaldoller/txs

export const bscapidetails = {
    BSC_API_URL:"https://rusd-supply-api.ribg.digital/royaldoller/txs", // for fetch the transactions
    BSC_API_URL_POST:"https://rusd-supply-api.ribg.digital/royaldoller/tx" // for fetch the transactions
}

export const euroReserved = "https://rusd-por-api.ribg.digital/don-4/euro-cash-reserves"

export const TokenToAddress = [
    {"MAAL":maal},
    {"BNB":bnb},
    // {"ETH":eth},
    // {"BTC":btc},
]

export const coinGeckoIDbyName = {
  "MAAL":maalID,
  "BNB":bnbID,
  // "ETH":ethID,
  // "BTC":btcID,
}

export const defaultchainid = "56"

export const ReservedToken = {
    "MAAL":{
        isNative:false,
        address:maal,
        coingeckoid:'maal-chain'
    },
    "BNB":{
        isNative:true,
        address:bnb,
        coingeckoid:'binancecoin'
    },
    // "ETH":{
    //     isNative:false,
    //     address:eth,
    //     coingeckoid:'ethereum'
    // },
    // "BTC":{
    //     isNative:false,
    //     address:btc,
    //     coingeckoid:'bitcoin'
    // },
}

export const USD_TEST_NET = {
    RMN:"0x6b3b95B0c84f35c9c505fff8C2F35Ee2e502a44D", // RMX = RUSD token for BSC
    RMN_ETH:"0xf5309d4971d187c1f315304442d45f84c6353a77", // RMX = RUSD token for ETH
    XAUS:"0x86a6101173732529fdAb7C10f14C6A9e063784b4", // not used
    ZERO:"0x0000000000000000000000000000000000000000" // not used
}

export const tokenOfNetworks = {
    "Polygon":"0xc2132D05D31c914a87C6611C10748AEb04B58e8F",
    "Binance Smart Chain":"0x55d398326f99059fF775485246999027B3197955",
    "Ethereum":"0xdAC17F958D2ee523a2206206994597C13D831ec7",
    "Mantle":"0xb78bA3A2c693BE007a2f05eAc658A9424f531A3f",
    "Sepolia":"0x86891b6932b76e4bD4bA1E592A803e110449A30A",
    "MaalChain":"0x165787Adc341F48BFf1baf07af60389daecf8DFf", // REUR Token
    "MaalChain Testnet":"0x930fbAe9E292e232E74E9243cc5A625D713D2FCb" // RMN Token
  }

export const tokenfromChain = {
    "7862":["REUR", "RXAU"],
    "7860":["RMN_TN", "RXAU_TN"],
    "56":["USDT"],
  }

  // now this will only work for mainnets
  export const addressFromSymbol = {
    "REUR":"0x165787Adc341F48BFf1baf07af60389daecf8DFf",
    "RXAU":"0x027c6273336e6490d318d5F40366fbb00489dd25",
    "USDT":"0x55d398326f99059fF775485246999027B3197955"
  }
  export const tokenLogofromChain = {
    "REUR":rmn,
    "RXAU":rmn,
    "USDT":usdt,
  }

  export const ChainLogofromChain = {
    "7862":maallogo,
    "7860":maallogo,
    "56":"https://assets.coingecko.com/coins/images/825/standard/bnb-icon2_2x.png?1696501970",
  }

  
  export const idToExplore = {
    "137":"https://polygonscan.com",
    "56":"https://bscscan.com",
    "1":"https://etherscan.io",
    "5001":"https://explorer.testnet.mantle.xyz",
    "11155111":"https://api.zan.top/eth-sepolia",
    "7862":"https://v2.maalscan.io",
    "7860":"https://testnet.maalscan.io",
  }

  export const idTorpc = {
    "137":"https://polygonscan.com",
    "56":"https://bsc-rpc.publicnode.com",
    "1":"https://mainnet.infura.io/v3/b4f414af9be54b1aa788f5fa2ed4020d",
    "5001":"https://explorer.testnet.mantle.xyz",
    "11155111":"https://endpoints.omniatech.io/v1/eth/sepolia/public",
    "7862":"https://node1-mainnet-new.maalscan.io",
    "7860":"https://node1.maalscan.io/",
  }

  export const idToSymbol = {
    "137":"POL",
    "56":"BNB",
    "1":"ETH",
    "5001":"MNT",
    "11155111":"ETH",
    "7862":"MAAL",
    "7860":"MAAL",
  }
  
  export const NetworkFromChainId = {
    "137":"Polygon",
    "56":"Binance Smart Chain",
    "1":"Ethereum",
    "5001":"Mantle",
    "11155111":"Sepolia",
    "7862":"MaalChain",
    "7860":"MaalChain Testnet",
  }

  export  const netowrkIDHEX = {
    "Polygon":"0x89",
    "Binance Smart Chain":"0x38",
    "Ethereum":"0x1",
    "Mantle":"0x1389",
    "Sepolia":"0xaa36a7",
    "MaalChain":"0x1eb6",
    "MaalChain Testnet":"0x1EB4"
  }
  export const idFromName = {
    "Polygon":"137",
    "Binance Smart Chain":"56",
    "Ethereum":"1",
    "Mantle":"5001",
    "Sepolia":"11155111",
    "MaalChain":"786",
    "MaalChain Testnet":"7860"
  }
